import React from 'react';
import '../styles/QuickActions.css';

function QuickActions({ previousQuestions, onQuestionClick }) {
  // Define categories for questions based on keywords
  const categorizeQuestion = (question) => {
    const text = question.text.toLowerCase();
    
    if (text.includes("bigfix")) {
      return "BigFix";
    } else if (text.includes("unica")) {
      return "Unica";
    } else if (text.includes("install") || text.includes("setup") || text.includes("configuration")) {
      return "Installation";
    } else if (text.includes("system") && text.includes("requirement")) {
      return "System Requirements";
    } else if (text.includes("troubleshoot") || text.includes("error") || text.includes("issue")) {
      return "Troubleshooting";
    } else if (text.includes("deploy") || text.includes("deployment")) {
      return "Deployment";
    } else {
      return "General";
    }
  };
  
  // Get the appropriate icon based on category
  const getCategoryIcon = (category) => {
    switch(category) {
      case "BigFix":
        return "computer";
      case "Unica":
        return "analytics";
      case "Installation":
        return "download";
      case "System Requirements":
        return "memory";
      case "Troubleshooting":
        return "build";
      case "Deployment":
        return "publish";
      default:
        return "chat";
    }
  };
  
  // Filter for questions with at least 3 words
  const validQuestions = previousQuestions
    // Remove duplicates by keeping only the first occurrence of each question
    .filter((question, index, self) => 
      self.findIndex(q => q.text === question.text) === index
    )
    // Filter for questions with 3+ words
    .filter(question => question.text && question.text.split(' ').length >= 3)
    // Add category to each question
    .map(question => ({
      ...question,
      category: categorizeQuestion(question)
    }))
    // Limit to 6 questions
    .slice(0, 6);

  return (
    <div className="quick-actions-container">
      <div className="quick-actions-header">
        <span className="material-icons">history</span>
        <span>Quick Actions</span>
      </div>
      
      <div className="quick-actions-scroller">
        {validQuestions.length === 0 ? (
          <div className="quick-actions-empty">
            Your previous questions will appear here
          </div>
        ) : (
          validQuestions.map((question, index) => (
            <div 
              key={index}
              className="quick-action-tile"
              onClick={() => onQuestionClick(question.text)}
              title={question.text}
            >
              <div className="quick-action-icon">
                <span className="material-icons">
                  {getCategoryIcon(question.category)}
                </span>
              </div>
              <div className="quick-action-content">
                <div className="quick-action-category">{question.category}</div>
                <div className="quick-action-text">{question.text}</div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default QuickActions;